export const ALERTS_CONFIGS_CONSTS = {
  marxent: {
    error: {
      data: {
        message: 'Something went wrong. Try again.',
        placement: 'top',
      },
      classList: ['pdp-toast--absolute'],
      teleport: {
        prefix: '#',
        selector: 'main-image-carousel',
        appendProductId: true,
      },
    },
  },
};

export default { ALERTS_CONFIGS_CONSTS };
